
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__stores__/[slug]",
      function () {
        return require("private-next-pages/__stores__/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__stores__/[slug]"])
      });
    }
  